"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InternalChatsContext = void 0;
const ChatsContext_1 = require("./ChatsContext");
exports.InternalChatsContext = (0, ChatsContext_1.createChatContext)();
